// extracted by mini-css-extract-plugin
export default {"InvoiceData":"InvoiceData_InvoiceData__LLW+3"};